import { useCallback } from 'react';
import { useLingui } from '@lingui/react/macro';
import { differenceInDays, isSameDay } from 'date-fns';
import { useCurrentDateInTimezoneGetter } from './use-current-date-in-timezone-getter';
import { useDateFormatter } from './use-date-formatter';
import { useWeekdayFormatter } from './use-weekday-formatter';

export const useRelativeDateFormatter = () => {
  const getCurrentDateInTimezone = useCurrentDateInTimezoneGetter();
  const formatDate = useDateFormatter();
  const formatWeekday = useWeekdayFormatter();
  const { t } = useLingui();

  return useCallback(
    (date: Date) => {
      const now = getCurrentDateInTimezone();
      const isDatePast = now.getTime() > date.getTime();

      const days = differenceInDays(date, now);

      if (isSameDay(now, date) && !isDatePast) {
        return t`today`;
      }

      if (days < 1) {
        return t`tomorrow`;
      }

      if (days < 7) {
        const weekday = formatWeekday(date);
        return t`on ${weekday}`;
      }

      return formatDate(date);
    },
    [formatDate, formatWeekday, getCurrentDateInTimezone]
  );
};
